import React, { useEffect, useState, useContext, useRef } from "react";
import { toast } from "react-toastify";
import { WarehouseContext } from "../../../Utility/UserContext";
import {
  getItemSales,
  deleteItemOrder,
  createItemSalesReturn,
  getItemSalesReturns,
  ListOrderById,
  getInvoiceNumber
} from "../../../Utility/Api";
import { Pagination, Deletemodel } from "../../Common/Functions";
import {
  getFormattedCurrentDate2,
  onReqCreatePayment,
  company_logo,
  AmountInWords
} from "../../../Utility/function";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import ThermalModal from "../SalesWindow/modal/ThermalModal";
import ItemSalesInvoiceModal from './ItemSalesInvoiceModal';

const ordersPerPage = 10;

const ItemSalesList = () => {
  const { showLoader, hideLoader, shopItem, UserItem } = useContext(WarehouseContext);
  const [ordersList, setOrdersList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [textFilter, setTextFilter] = useState("");
  
  // Modals state
  const [orderModal, setOrderModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState([]);
  const [orderItems, setOrderItems] = useState([]);
  const [selectedOrderData, setSelectedOrderData] = useState(null);

  // Return state
  const [showReturnModal, setShowReturnModal] = useState(false);
  const [returnOrder, setReturnOrder] = useState(null);
  const [returnItems, setReturnItems] = useState([]);
  const [returnQtys, setReturnQtys] = useState({});
  const [returnReason, setReturnReason] = useState("");
  const [returnRefundType, setReturnRefundType] = useState("bank");
  const [returnInvoiceNo, setReturnInvoiceNo] = useState("");
  const [globalReturns, setGlobalReturns] = useState([]);

  // Delete state
  const [deleteId, setDeleteId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  // Pay Modal
  const [pamentsModel, setpamentsModel] = useState(false);
  const [Paymentvalue, setPaymentvalue] = useState(null);
  const [cashAmount, setCashAmount] = useState(0);
  const [cardAmount, setCardAmount] = useState(0);

  // Print Invoice Modal States
  const [showModal, setShowModal] = useState(false);
  const [Details, setDetails] = useState({});
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [selectedReturnInvoice, setSelectedReturnInvoice] = useState([]);
  const [RemarkData, setRemarkData] = useState({});
  const [selectedLanguage, setSelectedLanguage] = useState("english");
  const [printVisible, setPrintVisible] = useState("");

  // Sales Invoice revisit modal
  const [showInvoiceModal2, setShowInvoiceModal2] = useState(false);
  const [invoiceData2, setInvoiceData2] = useState(null);
  
  const componentRef = useRef(null);
  const modalContentRef = useRef(null);
  const printerType = localStorage.getItem("printerType") || "0";
  const [companyInfo, setCompanyInfo] = useState({
    name: "Company Name",
    address: "123 Business Street, City, State 12345",
    phone: "(123) 456-7890",
    email: "info@yourcompany.com"
  });

  useEffect(() => {
    if (shopItem) {
      setCompanyInfo({
        name: shopItem?.title || "",
        address: shopItem?.Address || "123 Business Street, City, State 12345",
        phone: shopItem?.phone1 || "",
        email: shopItem?.email || ""
      });
      setRemarkData({
        terms: shopItem?.terms_and_conditions || ""
      });
    }
  }, [shopItem]);

  const fetchOrders = async (page = 1) => {
    try {
      showLoader();
      const shopId = shopItem?.shop_id || shopItem?.id;
      const response = await getItemSales(page, textFilter, shopId);
      if (response.data && response.data.data) {
        setOrdersList(response.data.data);
        setTotalPages(response.data.pagination?.total_pages || 1);
      }
    } catch (error) {
      console.error("Error fetching item sales:", error);
      toast.error("Failed to fetch item sales list");
    } finally {
      hideLoader();
    }
  };

  const fetchGlobalReturns = async () => {
    try {
      const res = await getItemSalesReturns().catch(() => ({ data: { data: [] } }));
      setGlobalReturns(res.data?.data || []);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    fetchOrders(currentPage);
    fetchGlobalReturns();
  }, [currentPage, shopItem]);

  const handleSearch = (e) => {
    e.preventDefault();
    setCurrentPage(1);
    fetchOrders(1);
  };

  const getOrderReturnedAmount = (orderId, orderMasterId) => {
    let totalReturned = 0;
    globalReturns.forEach((ret) => {
      let retData = [];
      try {
        retData = JSON.parse(ret.return_data || "[]");
      } catch (e) {}

      if (Array.isArray(retData)) {
        retData.forEach((retItem) => {
          const isMatch =
            retItem.om_id == orderMasterId ||
            retItem.unique_id === orderId ||
            (ret.unique_id && ret.unique_id.includes(orderId));

          if (isMatch) {
            totalReturned += parseFloat(retItem.amount || 0);
          }
        });
      }
    });
    return totalReturned;
  };

  const handleGetpayment = async (state) => {
    try {
      showLoader();
      setOrderModal(true);
      setSelectedOrder([]);
      setOrderItems([]);
      setSelectedOrderData(state);
      
      const [paymentRes] = await Promise.all([
        ListOrderById(state.order_id)
      ]);
      
      if (paymentRes.data && paymentRes.data.payment) {
        setSelectedOrder(paymentRes.data.payment);
      } else {
        setSelectedOrder([]);
      }
      
      setOrderItems(state.details || []);
      hideLoader();
    } catch (error) {
      hideLoader();
      setSelectedOrder([]);
      setOrderItems([]);
      console.error("Error fetching order details:", error);
    }
  };

  const handleGet = (state) => {
    setDetails(state);
    setSelectedInvoice(state.details || []);
    setSelectedReturnInvoice([]);
    setShowModal(true);
  };

  const handleViewInvoice = (order) => {
    const details = order.details || [];
    const subTotal = details.reduce((sum, d) => sum + parseFloat(d.p_price || 0), 0);
    const discount = parseFloat(order.discount || 0);
    const amountDue = parseFloat(order.overall_price || 0);
    const mappedProducts = details.map((d) => ({
      product_name: d.product_title || `Item #${d.item_id}`,
      qty: d.qty,
      // unit_title comes from backend (d.unit_title or d.unit_name) — fallback to ''
      unit_title: d.unit_title || d.unit_name || '',
      sell_price: parseFloat(d.qty) > 0 ? parseFloat(d.p_price || 0) / parseFloat(d.qty || 1) : 0,
      discount_type: '%',
      discount_value: 0,
      total: parseFloat(d.p_price || 0),
      offer_type: d.is_free === '1' ? 'free' : '',
    }));
    setInvoiceData2({
      invoiceNo: order.order_id,
      orderId: order.order_id,
      date: order.create_date ? new Date(order.create_date).toLocaleDateString('en-IN') : '',
      time: order.create_date ? new Date(order.create_date).toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit' }) : '',
      customerName: order.customer_name || 'Walk-in Customer',
      customerPhone: order.customer_phone || '',
      products: mappedProducts,
      subTotal,
      overDiscountAmount: discount,
      amountDue,
      paymentType: String(order.purchase_unit || '1'),
      returnTotal: 0,
    });
    setShowInvoiceModal2(true);
  };


  const handlePrint = async () => {
    setPrintVisible("d-none");
    setTimeout(async () => {
      const content = modalContentRef.current;
      if (!content) return;
      try {
        const canvas = await html2canvas(content, { scale: 3 });
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("p", "mm", "a4");
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        const imgWidth = 200;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        const xOffset = (pdfWidth - imgWidth) / 2;
        const yOffset = (pdfHeight - imgHeight) / 2;

        pdf.addImage(imgData, "PNG", xOffset, yOffset, imgWidth, imgHeight);
        const pdfBlob = pdf.output("blob");
        const pdfUrl = URL.createObjectURL(pdfBlob);
        const printWindow = window.open(pdfUrl, "_blank");
        if (printWindow) {
          printWindow.onload = () => {
            printWindow.print();
          };
        }
        URL.revokeObjectURL(pdfUrl);
        setTimeout(() => {
          setPrintVisible("");
        }, 1000);
      } catch (error) {
        setPrintVisible("");
        console.error(error);
      }
    }, 10);
  };

  const handlePrint1 = async () => {
    const content = componentRef.current;
    if (!content) return;
    try {
      const canvas = await html2canvas(content, { scale: 3 });
      const imgData = canvas.toDataURL("image/png");
      const contentHeightMm = (canvas.height * 80) / canvas.width;
      
      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: [80, contentHeightMm + 2],
      });

      pdf.addImage(imgData, "PNG", 0, 0, 80, contentHeightMm);
      const pdfBlob = pdf.output("blob");
      const pdfUrl = URL.createObjectURL(pdfBlob);
      const printWindow = window.open(pdfUrl, "_blank");
      if (printWindow) {
        printWindow.onload = () => {
          printWindow.print();
        };
      }
      URL.revokeObjectURL(pdfUrl);
    } catch (error) {
      console.error(error);
    }
  };

  const handleOpenReturn = async (order) => {
    try {
      showLoader();
      setReturnOrder(order);
      setReturnItems(order.details || []);
      setReturnQtys({});
      setReturnReason("");
      setReturnRefundType("bank");

      const shopId = shopItem?.shop_id || shopItem?.id || "1";
      const invRes = await getInvoiceNumber(4);
      if (invRes.data?.invoice_no) {
        setReturnInvoiceNo(invRes.data.invoice_no);
      } else {
        setReturnInvoiceNo(`RN${new Date().getFullYear()}-SH${shopId}-0001`);
      }
    } catch (e) {
      console.error(e);
      setReturnInvoiceNo(`RN${new Date().getFullYear()}-SH1-0001`);
    } finally {
      hideLoader();
      setShowReturnModal(true);
    }
  };

  const getUnitPrice = (item) => {
    const qty = parseFloat(item.qty || 1);
    const pPrice = parseFloat(item.p_price || 0);
    return qty > 0 ? pPrice / qty : 0;
  };

  const getAlreadyReturnedQty = (detailId) => {
    let count = 0;
    globalReturns.forEach((ret) => {
      let retData = [];
      try {
        retData = JSON.parse(ret.return_data || "[]");
      } catch (e) {}
      if (Array.isArray(retData)) {
        retData.forEach((item) => {
          if (String(item.id) === String(detailId)) {
            count += parseFloat(item.returnqty || 0);
          }
        });
      }
    });
    return count;
  };

  const handleReturnQtyChange = (detailId, val, maxVal) => {
    let num = parseFloat(val) || 0;
    if (num < 0) num = 0;
    if (num > maxVal) num = maxVal;
    setReturnQtys((prev) => ({ ...prev, [detailId]: num }));
  };

  const calcReturnFinancials = () => {
    let totalReturn = 0;
    returnItems.forEach((it) => {
      const qty = returnQtys[it.id] || 0;
      const unitPrice = getUnitPrice(it);
      totalReturn += qty * unitPrice;
    });

    const returnedAmt = getOrderReturnedAmount(returnOrder?.order_id, returnOrder?.id);
    const creditBalance = Math.max(0, parseFloat(returnOrder?.remaining || 0) - returnedAmt);

    const creditAdjust = Math.min(totalReturn, creditBalance);
    const refundAmount = Math.max(0, totalReturn - creditAdjust);
    const newCredit = Math.max(0, creditBalance - creditAdjust);
    return { totalReturn, creditAdjust, refundAmount, newCredit };
  };

  const handleSubmitReturn = async () => {
    const selectedItems = returnItems.filter((it) => (returnQtys[it.id] || 0) > 0);
    if (selectedItems.length === 0) {
      toast.error("Please select at least one item to return");
      return;
    }

    try {
      showLoader();
      const fin = calcReturnFinancials();
      const shopId = shopItem?.shop_id || shopItem?.id || "1";

      const returnPayloads = selectedItems.map((it) => {
        const qty = returnQtys[it.id];
        const unitPrice = getUnitPrice(it);
        return {
          id: it.id,
          om_id: it.om_id,
          p_id: it.item_id,
          product_name: it.product_title || `Item #${it.item_id}`,
          returnqty: qty,
          amount: (qty * unitPrice).toFixed(2),
        };
      });

      await createItemSalesReturn({
        unique_id: returnOrder?.order_id,
        return_invoice_no: returnInvoiceNo,
        amount: fin.totalReturn.toFixed(2),
        credit_adjustment: fin.creditAdjust.toFixed(2),
        refund_amount: fin.refundAmount.toFixed(2),
        status: returnRefundType === "payable" ? "1" : "0",
        shop_id: shopId,
        user_id: UserItem?.user_id || "",
        return_data: JSON.stringify(returnPayloads),
      });

      toast.success("Item return processed successfully");
      setShowReturnModal(false);
      fetchOrders(currentPage);
      fetchGlobalReturns();
    } catch (error) {
      console.error(error);
      toast.error("Failed to submit return");
    } finally {
      hideLoader();
    }
  };

  const handleDeleteClick = (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    try {
      showLoader();
      const res = await deleteItemOrder(deleteId);
      if (res.data?.status === "success") {
        toast.success("Order deleted successfully");
        setShowDeleteModal(false);
        fetchOrders(currentPage);
      } else {
        toast.error(res.data?.message || "Failed to delete order");
      }
    } catch (e) {
      toast.error("Error deleting order");
    } finally {
      hideLoader();
    }
  };

  const Handlepaymentmodel = (item) => {
    setCashAmount(0);
    setCardAmount(0);
    setPaymentvalue(item);
    setpamentsModel(true);
  };

  const handleCashChange = (e) => {
    const val = parseFloat(e.target.value) || 0;
    const maxVal = parseFloat(Paymentvalue?.remaining || 0) - card;
    if (val >= 0 && val <= maxVal) {
      setCashAmount(e.target.value);
    }
  };

  const handleCardChange = (e) => {
    const val = parseFloat(e.target.value) || 0;
    const maxVal = parseFloat(Paymentvalue?.remaining || 0) - cash;
    if (val >= 0 && val <= maxVal) {
      setCardAmount(e.target.value);
    }
  };

  const onHandlePayCredit = async () => {
    try {
      showLoader();
      const cash = parseFloat(cashAmount || 0);
      const card = parseFloat(cardAmount || 0);
      const remainingAmount = Math.max(0, parseFloat(Paymentvalue?.remaining || 0) - (cash + card));

      const paydata = {
        orderID: Paymentvalue?.order_id,
        date: getFormattedCurrentDate2(),
        amount: "0",
        total_amount: Paymentvalue.overall_price,
        cash: cash,
        credit: 0,
        card: card,
        type: 2, // Sales
        mop: "1",
        complete: remainingAmount <= 0 ? "1" : "0",
      };

      if (cash && card) {
        paydata.cash = cash;
        paydata.card = card;
        paydata.mop = "1,4";
      } else if (cash) {
        paydata.cash = cash;
        paydata.mop = "1";
      } else if (card) {
        paydata.card = card;
        paydata.mop = "4";
      }

      if (remainingAmount > 0) {
        paydata.credit = remainingAmount;
        paydata.mop = paydata.mop + ",2";
      }

      await onReqCreatePayment(paydata);
      toast.success("Payment registered successfully");
      setpamentsModel(false);
      fetchOrders(currentPage);
    } catch (error) {
      toast.error("Error processing payment");
    } finally {
      hideLoader();
    }
  };

  const cash = parseFloat(cashAmount || 0);
  const card = parseFloat(cardAmount || 0);
  const totalPayment = cash + card;
  const remainingAmount = Math.max(0, parseFloat(Paymentvalue?.remaining || 0) - totalPayment);
  const paidAmount = selectedOrder
    ?.filter((item) => item.mop != "2")
    .reduce((sum, item) => sum + parseFloat(item.amount || 0), 0);

  return (
    <div className="page-wrappers">
      <div className="page-content">
        
        {/* Header */}
        <div className="mb-4 d-flex justify-content-between align-items-center bg-white p-3 rounded-2xl border border-slate-100 shadow-sm">
          <div className="text-start">
            <h3 className="mb-1 fw-bold text-slate-800 tracking-tight" style={{ fontSize: "24px" }}>Item Sales List</h3>
            <p className="text-sm text-slate-500 mb-0 font-medium">View and manage completed item sales orders</p>
          </div>
          {/* <form className="d-flex align-items-center gap-2" onSubmit={handleSearch}>
            <input
              type="text"
              className="form-control"
              placeholder="Search Order ID..."
              value={textFilter}
              onChange={(e) => setTextFilter(e.target.value)}
              style={{ borderRadius: "8px", minWidth: "220px" }}
            />
            <button className="btn btn-primary" type="submit" style={{ borderRadius: "8px" }}>Search</button>
          </form> */}
        </div>

        {/* Orders Table */}
        <div className="card border-0 shadow-sm rounded-2xl">
          <div className="card-body p-4">
            <div className="table-responsive">
              <table className="table table-hover table-align-middle text-center mb-4" style={{ fontFamily: "Poppins" }}>
                <thead className="table-light">
                  <tr>
                    <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">#</th>
                    <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">Unique ID</th>
                    <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">Customer</th>
                    <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">Date</th>
                    <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">Total Price (INR)</th>
                    <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">Action</th>
                    <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider"></th>
                  </tr>
                </thead>
                <tbody>
                  {ordersList.length > 0 ? (
                    ordersList.map((order, index) => {
                      const returnedAmt = getOrderReturnedAmount(order.order_id, order.id);
                      const rem = Math.max(0, parseFloat(order.remaining || 0) - returnedAmt);
                      const isReturned = returnedAmt > 0 && rem === 0;

                      return (
                        <tr key={order.id} className="align-middle border-bottom border-slate-100">
                          <td className="text-sm font-semibold text-slate-700 py-3">{(currentPage - 1) * ordersPerPage + index + 1}</td>
                          <td className="text-sm font-semibold text-slate-700">{order.order_id}</td>
                          <td className="text-sm text-slate-600" style={{ maxWidth: "200px", whiteSpace: "normal", overflowWrap: "break-word" }}>{order.customer_name || "Walk-in Customer"}</td>
                          <td className="text-sm text-slate-600">{new Date(order.create_date).toLocaleString()}</td>
                          <td className="text-sm font-semibold text-slate-700">{parseFloat(order.overall_price || 0).toFixed(2)}</td>
                          <td className="text-sm text-slate-600">
                            <div className="d-flex align-items-center gap-2 justify-content-center">
                              <img
                                src="/assets/images/icons/view.png"
                                onClick={() => handleGetpayment(order)}
                                style={{ height: "16px", cursor: "pointer" }}
                                alt="View"
                              />
                              <div className="d-flex gap-1">
                                <button
                                  className="btn btn-danger btn-sm py-0.5 px-2"
                                  style={{ fontSize: "11px", borderRadius: "4px" }}
                                  onClick={() => handleOpenReturn(order)}
                                  title="Process Return"
                                >
                                  Return
                                </button>
                                {returnedAmt === 0 && (
                                  <button
                                    className="btn btn-outline-danger btn-sm py-0.5 px-2"
                                    style={{ fontSize: "11px", borderRadius: "4px" }}
                                    onClick={() => handleDeleteClick(order.id)}
                                    title="Delete Order"
                                  >
                                    Delete
                                  </button>
                                )}
                                <button
                                  className="btn btn-outline-primary btn-sm py-0.5 px-2"
                                  style={{ fontSize: "11px", borderRadius: "4px" }}
                                  onClick={() => handleViewInvoice(order)}
                                  title="View Invoice"
                                >
                                  <i className="bi bi-receipt me-1" />Invoice
                                </button>
                              </div>
                            </div>
                          </td>
                          <td className="text-sm text-slate-600">
                            <div className="d-flex justify-content-center">
                              {rem > 0 && !isReturned ? (
                                <button
                                  className="btn btn-warning btn-sm"
                                  style={{ minWidth: "80px", borderRadius: "4px" }}
                                  onClick={() => Handlepaymentmodel(order)}
                                >
                                  Pay
                                </button>
                              ) : (
                                <button className="btn btn-success btn-sm" style={{ minWidth: "80px", borderRadius: "4px" }} disabled>
                                  {isReturned ? "Returned" : "Paid"}
                                </button>
                              )}
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="7" className="text-center py-4 text-slate-400">No item sales found</td>
                    </tr>
                  )}
                </tbody>
              </table>
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
          </div>
        </div>

        {/* View Details Modal */}
        {orderModal && selectedOrderData && (
          <OrderDetailsModal
            orders={selectedOrder}
            orderItems={orderItems}
            isOpen={orderModal}
            onClose={() => setOrderModal(false)}
            selectedOrder={selectedOrderData}
            handleGet={handleGet}
          />
        )}

        {/* Process Return Modal */}
        {showReturnModal && returnOrder && (() => {
          const fin = calcReturnFinancials();
          return (
            <div
              className="modal fade show"
              style={{ display: "block", background: "rgba(0,0,0,0.55)", zIndex: 1060 }}
              tabIndex="-1"
            >
              <div className="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
                <div className="modal-content" style={{ borderRadius: "14px", border: "none", boxShadow: "0 20px 60px rgba(0,0,0,0.25)" }}>
                  
                  {/* Header */}
                  <div className="modal-header" style={{ background: "linear-gradient(135deg, #dc3545 0%, #b02a37 100%)", borderRadius: "14px 14px 0 0" }}>
                    <div>
                      <h5 className="modal-title text-white fw-bold mb-0">
                        🔄 Process Item Sales Return
                      </h5>
                      <small className="text-white opacity-75">
                        Order: {returnOrder?.order_id} &nbsp;|&nbsp; Customer: {returnOrder?.customer_name || "Walk-in Customer"}
                      </small>
                    </div>
                    <button type="button" className="btn-close btn-close-white" onClick={() => setShowReturnModal(false)} />
                  </div>

                  {/* Body */}
                  <div className="modal-body p-4">
                    <h6 className="fw-bold mb-3 text-dark">Select Items to Return</h6>
                    {returnItems.length === 0 ? (
                      <div className="text-center text-muted py-4">No items found for this order.</div>
                    ) : (
                      <div className="table-responsive mb-4">
                        <table className="table table-bordered table-sm align-middle text-center">
                          <thead className="table-light">
                            <tr>
                              <th>#</th>
                              <th>Item</th>
                              <th className="text-center">Sold Qty</th>
                              <th className="text-center text-danger">Returned Qty</th>
                              <th className="text-center">Unit Price</th>
                              <th className="text-center" style={{ width: "160px" }}>Return Qty</th>
                              <th className="text-end">Return Amount</th>
                            </tr>
                          </thead>
                          <tbody>
                            {returnItems.map((it, idx) => {
                              const alreadyRet = getAlreadyReturnedQty(it.id);
                              const soldQty = parseFloat(it.qty || 0) + alreadyRet;
                              const remainingQty = parseFloat(it.qty || 0);
                              const retQty = returnQtys[it.id] || 0;
                              const unitPrice = getUnitPrice(it);
                              const retAmt = retQty * unitPrice;

                              return (
                                <tr key={it.id} className={retQty > 0 ? "table-danger" : ""}>
                                  <td>{idx + 1}</td>
                                  <td className="text-start">
                                    <div className="fw-semibold">
                                      {it.product_title || `Item #${it.item_id}`}
                                    </div>
                                  </td>
                                  <td className="text-center">{soldQty}</td>
                                  <td className="text-center text-danger fw-semibold">{alreadyRet > 0 ? alreadyRet : "—"}</td>
                                  <td className="text-center">₹{unitPrice.toFixed(2)}</td>
                                  <td className="text-center" style={{ width: "160px" }}>
                                    {remainingQty <= 0 ? (
                                      <span className="badge bg-danger">Fully Returned</span>
                                    ) : (
                                      <div className="d-flex align-items-center gap-1 justify-content-center">
                                        <button
                                          className="btn btn-outline-secondary btn-sm px-2 py-0"
                                          onClick={() => handleReturnQtyChange(it.id, (retQty - 1).toString(), remainingQty)}
                                        >−</button>
                                        <input
                                          type="number"
                                          className="form-control form-control-sm text-center"
                                          style={{ width: "80px" }}
                                          value={retQty}
                                          min={0}
                                          max={remainingQty}
                                          onChange={(e) => handleReturnQtyChange(it.id, e.target.value, remainingQty)}
                                        />
                                        <button
                                          className="btn btn-outline-secondary btn-sm px-2 py-0"
                                          onClick={() => handleReturnQtyChange(it.id, (retQty + 1).toString(), remainingQty)}
                                        >+</button>
                                      </div>
                                    )}
                                  </td>
                                  <td className="text-end fw-semibold">
                                    {retQty > 0 ? `₹${retAmt.toFixed(2)}` : "—"}
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    )}

                    {/* Financial Summary */}
                    <div className="card border-0 mb-3" style={{ background: "#f8f9fa" }}>
                      <div className="card-body p-3">
                        <h6 className="fw-bold mb-3" style={{ color: "#dc3545" }}>Financial Summary</h6>
                        <div className="row g-2">
                          <div className="col-6">
                            <div className="d-flex justify-content-between border-bottom pb-2">
                              <span className="text-muted small">Total Return Value</span>
                              <span className="fw-bold">₹{fin.totalReturn.toFixed(2)}</span>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="d-flex justify-content-between border-bottom pb-2">
                              <span className="text-muted small">Customer Credit Balance</span>
                              <span className="fw-bold text-info">₹{Math.max(0, parseFloat(returnOrder?.remaining || 0) - getOrderReturnedAmount(returnOrder?.order_id, returnOrder?.id)).toFixed(2)}</span>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="d-flex justify-content-between border-bottom pb-2">
                              <span className="text-muted small">Credit Adjusted</span>
                              <span className="fw-bold text-warning">−₹{fin.creditAdjust.toFixed(2)}</span>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="d-flex justify-content-between border-bottom pb-2">
                              <span className="text-muted small">Refund Amount</span>
                              <span className="fw-bold text-success">₹{fin.refundAmount.toFixed(2)}</span>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="d-flex justify-content-between">
                              <span className="text-muted small">New Credit Balance</span>
                              <span className="fw-bold text-primary">₹{fin.newCredit.toFixed(2)}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Refund Type Toggle */}
                    {fin.refundAmount > 0 && (
                      <div className="mb-3">
                        <label className="fw-semibold mb-2 d-block">How to handle ₹{fin.refundAmount.toFixed(2)} refund?</label>
                        <div className="d-flex gap-3">
                          <div
                            className={`flex-fill p-3 rounded border-2 cursor-pointer ${returnRefundType === "bank" ? "border border-danger bg-danger bg-opacity-10" : "border"}`}
                            style={{ cursor: "pointer" }}
                            onClick={() => setReturnRefundType("bank")}
                          >
                            <div className="d-flex align-items-center gap-2">
                              <input type="radio" checked={returnRefundType === "bank"} onChange={() => setReturnRefundType("bank")} />
                              <div>
                                <div className="fw-bold small">Refund to Bank</div>
                                <div className="text-muted" style={{ fontSize: "11px" }}>Cash paid back to customer now</div>
                              </div>
                            </div>
                          </div>
                          <div
                            className={`flex-fill p-3 rounded border-2 cursor-pointer ${returnRefundType === "payable" ? "border border-primary bg-primary bg-opacity-10" : "border"}`}
                            style={{ cursor: "pointer" }}
                            onClick={() => setReturnRefundType("payable")}
                          >
                            <div className="d-flex align-items-center gap-2">
                              <input type="radio" checked={returnRefundType === "payable"} onChange={() => setReturnRefundType("payable")} />
                              <div>
                                <div className="fw-bold small">Keep as Customer Credit</div>
                                <div className="text-muted" style={{ fontSize: "11px" }}>Reduce on next sale or pay later</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Return Reason */}
                    <div className="mb-2">
                      <label className="fw-semibold mb-1 small">Return Reason <span className="text-muted">(optional)</span></label>
                      <textarea
                        className="form-control form-control-sm"
                        rows={2}
                        placeholder="e.g. Damaged product, Wrong item..."
                        value={returnReason}
                        onChange={(e) => setReturnReason(e.target.value)}
                      />
                    </div>

                    <div className="text-muted small">
                      Return Invoice#: <strong>{returnInvoiceNo}</strong>
                    </div>

                  </div>

                  {/* Footer */}
                  <div className="modal-footer border-0 pt-0">
                    <button
                      className="btn btn-secondary"
                      onClick={() => setShowReturnModal(false)}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn btn-danger fw-bold"
                      onClick={handleSubmitReturn}
                      disabled={fin.totalReturn === 0}
                    >
                      Confirm Return — ₹{fin.totalReturn.toFixed(2)}
                    </button>
                  </div>

                </div>
              </div>
            </div>
          );
        })()}

        {showDeleteModal && (
          <Deletemodel
            setShowModal={setShowDeleteModal}
            handleDelete={confirmDelete}
          />
        )}

        {showInvoiceModal2 && invoiceData2 && (
          <ItemSalesInvoiceModal
            invoiceData={invoiceData2}
            onClose={() => { setShowInvoiceModal2(false); setInvoiceData2(null); }}
          />
        )}

        {/* Pay Credit Modal */}
        {pamentsModel && Paymentvalue && (
          <div
            className="modal fade show"
            style={{ display: "block", background: "rgba(0,0,0,0.55)", zIndex: 1060 }}
            tabIndex="-1"
            role="dialog"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content p-3" style={{ borderRadius: "12px", boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)" }}>
                
                {/* Modal Header */}
                <div className="modal-header border-0">
                  <h5 className="modal-title fw-bold text-dark font-18">Payment</h5>
                  <button type="button" className="btn-close" onClick={() => setpamentsModel(false)}></button>
                </div>

                {/* Modal Body */}
                <div className="modal-body">
                  <div className="p-3 bg-light rounded text-start">
                    <p className="mb-2">Sales ID: <span className="fw-bold">{Paymentvalue?.order_id}</span></p>
                    <p className="mb-2">Customer Name: <span className="fw-bold">{Paymentvalue?.customer_name || "Walk-in Customer"}</span></p>
                    <hr />
                    <div>
                      <p className="mb-2 d-flex justify-content-between">
                        <span>Amount:</span>
                        <span className="text-primary fw-bold">₹{parseFloat(Paymentvalue?.overall_price || 0).toFixed(2)}</span>
                      </p>
                      <p className="mb-2 d-flex justify-content-between">
                        <span>Due Amount:</span>
                        <span className="text-danger fw-bold">₹{parseFloat(Paymentvalue?.remaining || 0).toFixed(2)}</span>
                      </p>
                      <p className="mb-2 d-flex justify-content-between align-items-center">
                        <span>Cash:</span>
                        <input
                          type="number"
                          className="form-control text-end w-25"
                          value={cashAmount}
                          onChange={handleCashChange}
                        />
                      </p>
                      <p className="mb-2 d-flex justify-content-between align-items-center">
                        <span>Card:</span>
                        <input
                          type="number"
                          className="form-control text-end w-25"
                          value={cardAmount}
                          onChange={handleCardChange}
                        />
                      </p>
                    </div>
                    <hr />
                    <p className="mb-0 fw-bold fs-5 text-end">
                      Remaining Amount: <span className="text-success fw-bold">₹{remainingAmount.toFixed(2)}</span>
                    </p>
                  </div>
                </div>

                {/* Modal Footer */}
                <div className="modal-footer border-0 d-flex justify-content-end">
                  <button type="button" className="btn btn-secondary me-2" onClick={() => setpamentsModel(false)}>Cancel</button>
                  <button
                    className="btn btn-success"
                    disabled={totalPayment <= 0 || totalPayment > parseFloat(Paymentvalue?.remaining || 0)}
                    onClick={onHandlePayCredit}
                  >
                    Pay Now
                  </button>
                </div>

              </div>
            </div>
          </div>
        )}

        {/* Invoice PDF Print Modal */}
        {showModal && (
          <div
            className={`modal fade ${showModal ? "show" : ""}`}
            tabIndex={-1}
            role="dialog"
            style={{ display: showModal ? "block" : "none", background: "rgba(0,0,0,0.55)", zIndex: 1060 }}
            aria-hidden={!showModal}
          >
            <div className={`modal-dialog ${printerType === "1" ? "modal-sm" : "modal-lg"}`} role="document">
              <div className="modal-content" ref={modalContentRef}>
                <div className="modal-header border-0 pb-0 mb-1">
                  <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
                </div>

                {printerType === "1" && (
                  <ThermalModal
                    ref={componentRef}
                    InvoiceDetail={Details}
                    Products={selectedInvoice}
                    ReturnItem={selectedReturnInvoice}
                    Payment={selectedOrder}
                    paidAmount={paidAmount}
                    companyInfo={companyInfo}
                  />
                )}

                {printerType === "0" && (
                  <>
                    <div className="d-flex justify-content-end mt-2 mx-4">
                      <div className="form-check form-check-inline mx-1">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="language"
                          id="english"
                          value="english"
                          checked={selectedLanguage === "english"}
                          onChange={() => setSelectedLanguage("english")}
                        />
                        <label className="form-check-label" htmlFor="english">English</label>
                      </div>
                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="language"
                          id="arabic"
                          value="arabic"
                          checked={selectedLanguage === "arabic"}
                          onChange={() => setSelectedLanguage("arabic")}
                        />
                        <label className="form-check-label" htmlFor="arabic">العربية</label>
                      </div>
                    </div>

                    <div className="row mx-3 mt-2">
                      <div className="d-flex justify-content-between align-items-center">
                        <div className="col-md-1">
                          <img
                            src={company_logo || "assets/images/tech_logo.webp"}
                            alt="Company Logo"
                            style={{ maxHeight: "38px" }}
                          />
                        </div>
                      </div>
                      <div className="col-12 text-center mt-2">
                        <p className="fw-bold font-14 mb-0">{companyInfo?.address}</p>
                        <p className="fw-medium font-13 mb-0">
                          Mobile: {companyInfo?.phone} | Email: {companyInfo?.email}
                        </p>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col text-center">
                        <h3 className="fw-bold mt-2">
                          {selectedLanguage === "arabic" ? "فاتورة" : "Invoice"}
                        </h3>
                      </div>
                    </div>

                    <div className="row border-top border-bottom pt-3 mx-3 pb-2">
                      <div className="col-6 text-start">
                        <div className="p-2" style={{ border: ".8px solid #dee2e6", minHeight: 150 }}>
                          <h6 className="fw-bold">
                            {selectedLanguage === "arabic" ? "تفاصيل العميل:" : "Customer Details:"}
                          </h6>
                          <div className="d-flex justify-content-between">
                            <span className="fw-semibold font-13">{selectedLanguage === "arabic" ? "الاسم:" : "Name:"}</span>
                            <span className="fw-bold font-13">{Details?.customer_name || "Walk-in Customer"}</span>
                          </div>
                          <div className="d-flex justify-content-between mt-1">
                            <span className="fw-semibold font-13">{selectedLanguage === "arabic" ? "البريد الإلكتروني:" : "Email:"}</span>
                            <span className="fw-bold font-13">{Details?.customer_email || "—"}</span>
                          </div>
                          <div className="d-flex justify-content-between mt-1">
                            <span className="fw-semibold font-13">{selectedLanguage === "arabic" ? "العنوان:" : "Address:"}</span>
                            <span className="fw-bold font-13">{Details?.additional_details || "—"}</span>
                          </div>
                          <div className="d-flex justify-content-between mt-1">
                            <span className="fw-semibold font-13">{selectedLanguage === "arabic" ? "الهاتف:" : "Phone:"}</span>
                            <span className="fw-bold font-13">{Details?.customer_phone || "—"}</span>
                          </div>
                        </div>
                      </div>
                      
                      <div className="col-6">
                        <table className="table table-bordered text-center align-middle m-0 mb-2">
                          <tbody>
                            <tr>
                              <td className="text-start fw-bold">
                                {selectedLanguage === "arabic" ? "رقم الفاتورة:" : "Inv No:"} {Details.order_id}
                              </td>
                              <td className="text-start fw-bold">
                                {selectedLanguage === "arabic" ? "التاريخ:" : "Date:"} {Details.create_date?.split('T')[0]}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table className="table table-bordered text-center align-middle">
                          <tbody>
                            <tr>
                              <td className="text-start d-flex justify-content-between">
                                <span className="fw-bold">{selectedLanguage === "arabic" ? "البائع:" : "Sales Person:"}</span>
                                <span className="fw-semibold">{Details?.user_name || "—"}</span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div className="row mt-4 mx-4">
                      <div
                        className="col-md-12"
                        style={{
                          position: "relative",
                          overflow: "hidden",
                          background: `linear-gradient(to bottom, rgba(255, 255, 255, 90%), rgba(255, 255, 255, 90%)), url(assets/images/tech_logo.webp) no-repeat center center / cover`,
                          backgroundSize: "60%",
                          backgroundPosition: "center",
                        }}
                      >
                        <div className="table-responsive">
                          <table className="table table-sm table-bordered w-100 text-center">
                            <thead className="table-light">
                              <tr className="bg-transparent">
                                <th className="bg-transparent">{selectedLanguage === "arabic" ? "الرقم" : "SL No."}</th>
                                <th className="bg-transparent">{selectedLanguage === "arabic" ? "التفاصيل" : "Particulars"}</th>
                                <th className="bg-transparent">{selectedLanguage === "arabic" ? "الكمية" : "Qty"}</th>
                                <th className="bg-transparent">{selectedLanguage === "arabic" ? "سعر الوحدة" : "Unit Price"}</th>
                                <th className="bg-transparent">{selectedLanguage === "arabic" ? "الخصم" : "Offer"}</th>
                                <th className="bg-transparent" colSpan={2}>{selectedLanguage === "arabic" ? "المبلغ الإجمالي" : "Total Amount"}</th>
                              </tr>
                            </thead>
                            <tbody>
                              {Array.isArray(selectedInvoice) && selectedInvoice.map((item, index) => {
                                const qty = parseFloat(item.qty || 1);
                                const pPrice = parseFloat(item.p_price || 0);
                                const unitPrice = qty > 0 ? pPrice / qty : 0;
                                return (
                                  <tr key={index} className="bg-transparent">
                                    <td className="bg-transparent">{index + 1}</td>
                                    <td className="bg-transparent text-center fw-semibold">{item.product_title || `Item #${item.item_id}`}</td>
                                    <td className="bg-transparent fw-semibold">{item.qty}</td>
                                    <td className="bg-transparent fw-semibold">₹{item.is_free === "1" ? "0.00" : unitPrice.toFixed(2)}</td>
                                    <td className="bg-transparent fw-semibold">{item.is_free === "1" ? "Offer Product" : "Normal sale"}</td>
                                    <td className="bg-transparent fw-semibold" colSpan={2}>₹{item.is_free === "1" ? "0.00" : pPrice.toFixed(2)}</td>
                                  </tr>
                                );
                              })}
                            </tbody>
                            <tfoot>
                              <tr>
                                <br />
                              </tr>
                              <tr className="bg-transparent">
                                <td colSpan={6} className="bg-transparent fw-bold text-end">{selectedLanguage === "arabic" ? "الإجمالي" : "Total"}:</td>
                                <td className="bg-transparent fw-bold">
                                  ₹{Array.isArray(selectedInvoice)
                                    ? selectedInvoice
                                      .filter(i => i.is_free !== "1")
                                      .reduce((sum, i) => sum + parseFloat(i.p_price || 0), 0)
                                      .toFixed(2)
                                    : "0.00"}
                                </td>
                              </tr>
                              
                              {Details.purchase_unit != 1 && (
                                <tr className="bg-transparent">
                                  <td colSpan={6} className="bg-transparent text-center fw-semibold">Payment History</td>
                                </tr>
                              )}

                              {Details.purchase_unit != 1 &&
                                selectedOrder
                                  ?.filter((item) => item.mop != "2")
                                  ?.map((item, index) => (
                                    <tr key={index} className="bg-transparent">
                                      <td colSpan={5} className="bg-transparent text-end fw-bold px-2">{item.date}</td>
                                      <td colSpan={1} className="bg-transparent text-end fw-bold px-2">
                                        {item.mop == "1" ? "Cash" : item.mop == "4" ? "Card" : item.mop == "3" ? "UPI" : item.mop == "1,4" ? "Cash & Card" : "Other"}
                                      </td>
                                      <td colSpan={1} className="bg-transparent text-center fw-semibold">
                                        ₹{parseFloat(item.amount || 0).toFixed(2)}
                                      </td>
                                    </tr>
                                  ))}

                              {Details.purchase_unit != 1 && (
                                <tr className="bg-transparent">
                                  <td colSpan={6} className="bg-transparent text-end fw-bold px-2">Remaining Balance</td>
                                  <td colSpan={1} className="bg-transparent text-center text-danger fw-semibold">
                                    ₹{(parseFloat(Details?.overall_price || 0) - parseFloat(paidAmount || 0)).toFixed(2)}
                                  </td>
                                </tr>
                              )}

                              <tr className="bg-transparent">
                                <td colSpan={7} className="bg-transparent text-start text-wrap">
                                  <p className="my-2">
                                    <strong>
                                      {selectedLanguage === "arabic" ? "المبلغ بالأحرف:" : "Amount In Words:"} &nbsp;
                                      {AmountInWords(Details?.overall_price)}
                                    </strong>
                                  </p>
                                </td>
                              </tr>
                            </tfoot>
                          </table>
                        </div>
                      </div>
                    </div>

                    <div className="row border-top border-bottom py-3 mx-3 mt-3">
                      <div className="col-10 col-md-4 d-flex text-start">
                        <div className="p-2 flex-fill d-flex flex-column" style={{ border: ".8px solid #dee2e6" }}>
                          <h6 className="fw-bold">{selectedLanguage === "arabic" ? "الشروط والأحكام" : "Terms & Condition:"}</h6>
                          <p className="mt-2 fs-8 flex-grow-1" style={{ whiteSpace: 'pre-wrap' }}>
                            {RemarkData?.terms || "Standard Terms and Conditions apply."}
                          </p>
                        </div>
                      </div>

                      <div className="col-12 col-md-4 d-flex text-start">
                        <div className="p-2 flex-fill d-flex flex-column" style={{ border: ".8px solid #dee2e6" }}>
                          <h6 className="fw-bold">{selectedLanguage === "arabic" ? "حساب البنك" : "Bank Account:"}</h6>
                          <p className="mt-2 fs-6 flex-grow-1">
                            Name: {shopItem?.bank_name || "N/A"}<br />
                            Bank: {shopItem?.bank_branch || "N/A"}<br />
                            {shopItem?.account_no ? `A/C No: ${shopItem.account_no}` : "N/A"}
                          </p>
                        </div>
                      </div>

                      <div className="col-12 col-md-4 d-flex text-start">
                        <div className="p-2 flex-fill d-flex flex-column" style={{ border: ".8px solid #dee2e6" }}>
                          <h6 className="fw-bold">{selectedLanguage === "arabic" ? "لشركة توب تكنو" : `For ${companyInfo.name}:`}</h6>
                          <p className="mt-2 fs-6 flex-grow-1">{companyInfo.name || "N/A"}</p>
                        </div>
                      </div>
                    </div>
                  </>
                )}

                <div className="modal-footer mx-1 mt-4 pb-4 pe-4">
                  <button
                    type="button"
                    className={"btn btn-info " + printVisible}
                    onClick={() => {
                      printerType === "0" ? handlePrint() : handlePrint1();
                    }}
                  >
                    Print
                  </button>
                </div>

              </div>
            </div>
          </div>
        )}

      </div>
    </div>
  );
};

const OrderDetailsModal = ({
  orders,
  orderItems,
  isOpen,
  onClose,
  selectedOrder,
  handleGet,
}) => {
  return (
    <div
      className={`modal fade ${isOpen ? "show" : ""}`}
      style={{ display: isOpen ? "block" : "none", background: "rgba(0,0,0,0.55)", zIndex: 1060 }}
      tabIndex="-1"
      role="dialog"
    >
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content p-3" style={{ borderRadius: "12px", boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)" }}>
          
          {/* Modal Header */}
          <div className="modal-header border-0">
            <h5 className="modal-title fw-bold text-dark font-18">Payment Details</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>

          {/* Modal Body */}
          <div className="modal-body pt-0">
            {selectedOrder && (
              <div className="mt-3">
                <table className="table table-bordered table-striped shadow-sm text-center">
                  <thead className="table-primary">
                    <tr>
                      <th colSpan="4">
                        <div className="d-flex justify-content-between align-items-center">
                          <span>Order Details</span>
                          <a
                            className="bg-gradient-blues rounded px-2 font-13 text-black pointer"
                            style={{ textDecoration: "none" }}
                            onClick={() => {
                              onClose();
                              handleGet(selectedOrder);
                            }}
                          >
                            Invoice
                          </a>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="fw-bold">Sales ID</td>
                      <td>{selectedOrder.order_id}</td>
                      <td className="fw-bold">Customer Name</td>
                      <td>{selectedOrder.customer_name || "Walk-in Customer"}</td>
                    </tr>
                    <tr>
                      <td className="fw-bold">Date</td>
                      <td>{selectedOrder.create_date ? selectedOrder.create_date.split('T')[0] : ""}</td>
                      <td className="fw-bold">Total Amount</td>
                      <td>₹{parseFloat(selectedOrder.overall_price || 0).toFixed(2)}</td>
                    </tr>
                    <tr>
                      <td className="fw-bold">Initial Paid</td>
                      <td>₹{parseFloat(selectedOrder.amount || 0).toFixed(2)}</td>
                      <td className="fw-bold">Remaining Amount</td>
                      <td>₹{parseFloat(selectedOrder.remaining || 0).toFixed(2)}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )}

            {/* Order Items */}
            <h6 className="modal-title fw-bold text-dark mt-3 text-start">Order Items</h6>
            <div className="table-responsive my-1 w-100">
              <table className="table table-sm table-bordered table-hover text-center">
                <thead className="table-light">
                  <tr>
                    <th>#</th>
                    <th>Item</th>
                    <th>Qty</th>
                    <th>Unit Price</th>
                    <th>Total</th>
                    <th>Type</th>
                  </tr>
                </thead>
                <tbody>
                  {orderItems && orderItems.length > 0 ? (
                    orderItems.map((item, index) => {
                      const qty = parseFloat(item.qty || 1);
                      const pPrice = parseFloat(item.p_price || 0);
                      const unitPrice = qty > 0 ? pPrice / qty : 0;
                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td className="fw-semibold text-start">{item.product_title || `Item #${item.item_id}`}</td>
                          <td>{item.qty}</td>
                          <td>₹{item.is_free === "1" ? "0.00" : unitPrice.toFixed(2)}</td>
                          <td className="fw-semibold">
                            {item.is_free === "1" ? <span className="text-success">Free</span> : `₹${pPrice.toFixed(2)}`}
                          </td>
                          <td>
                            <span className={`badge ${item.is_free === "1" ? "bg-success" : "bg-primary"}`}>
                              {item.is_free === "1" ? "Offer" : "Normal"}
                            </span>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="6" className="text-center text-muted">No items found</td>
                    </tr>
                  )}
                </tbody>
                {orderItems && orderItems.length > 0 && (
                  <tfoot>
                    <tr>
                      <td colSpan="4" className="text-end fw-bold">Grand Total:</td>
                      <td className="fw-bold">
                        ₹{orderItems
                          .filter(i => i.is_free !== "1")
                          .reduce((sum, i) => sum + parseFloat(i.p_price || 0), 0)
                          .toFixed(2)}
                      </td>
                      <td></td>
                    </tr>
                  </tfoot>
                )}
              </table>
            </div>

            {/* Payment History */}
            <h6 className="modal-title fw-bold text-dark text-start mt-3">Payment History</h6>
            <div className="table-responsive text-center my-1 w-100">
              <table className="table table-striped table-sm table-bordered">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Date</th>
                    <th>MOP</th>
                    <th>Amount (INR)</th>
                  </tr>
                </thead>
                <tbody>
                  {orders && orders.length > 0 ? (
                    orders
                      .filter((item) => item.mop != "2")
                      .map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item.date}</td>
                          <td>
                            {item.mop == "1" ? "Cash" : item.mop == "4" ? "Card" : item.mop == "3" ? "UPI" : item.mop == "1,4" ? "Cash & Card" : "Other"}
                          </td>
                          <td>₹{parseFloat(item.amount || 0).toFixed(2)}</td>
                        </tr>
                      ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="text-center text-muted">No payment history found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

          </div>

          {/* Modal Footer */}
          <div className="modal-footer border-0 d-flex justify-content-end pt-0">
            <button type="button" className="btn btn-secondary" onClick={onClose}>Close</button>
          </div>

        </div>
      </div>
    </div>
  );
};

export default ItemSalesList;
